export default __webpack_public_path__ + "ymca-building-white.svg";